import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';

export interface IMiDNIValidateResponse {
	result: 'OK' | 'KO';
	/** Solo presente cuando result === 'KO' */
	error?: string;
	/** Solo presente cuando result === 'OK' */
	process?: any[];
	process_uuid?: string;
}

@Injectable({
	providedIn: 'root',
})
export class MiDNIApiService extends ApiService {
	constructor() {
		super();
	}

	/**
	 * Envía los bytes crudos del QR MiDNI (base64) al backend para su validación.
	 * El backend verifica la firma ECDSA, la caducidad y extrae los datos de identidad.
	 * Si es válido, marca la operación OCR como completada.
	 * @param qrBase64 Bytes crudos del QR en base64
	 * @param frameBase64 Frame JPEG de la cámara en el momento de detección (base64 sin prefijo data URI)
	 */
	public validateQr(
		qrBase64: string,
		frameBase64: string,
		qrImageBase64?: string,
	): Observable<IMiDNIValidateResponse> {
		return this.http.post<IMiDNIValidateResponse>(
			environment.identity2 + '/midni/validate-qr',
			{ qr_data: qrBase64, frame_image: frameBase64, qr_image: qrImageBase64 ?? frameBase64 },
			{ headers: this.getHeaders() },
		);
	}
}
